import { request } from '../request'
import type { AxiosResponse } from 'axios'

import { AlertItem } from '@models/api/AlertItem'
import { AlertType } from '@models/api/AlertType'
import {
  MeteoAlertZoneDTO,
  MeteoAlertZoneType
} from '@models/api/MeteoAlertZoneDTO'
import { AlertProvinceDTO } from '@models/api/AlertProvinceDTO'

export const alerts = {
  getAlertTypes: function (): Promise<AxiosResponse<AlertType[]>> {
    return request.get('api/getFenomeno')
  },
  getAlerts: function (): Promise<AxiosResponse<AlertItem[]>> {
    return request.get('api/getAlerts')
  },

  getMeteoAlertZones: function (
    zoneType: MeteoAlertZoneType,
    includeGeometries: boolean
  ): Promise<AxiosResponse<MeteoAlertZoneDTO[]>> {
    return request.get(
      `api/alertZones?zones=${zoneType}&geometries=${includeGeometries}`
    )
  },

  getAlertProvinces: function (
    includeGeometries: boolean
  ): Promise<AxiosResponse<AlertProvinceDTO[]>> {
    return request.get(`api/alertProvinces?geometries=${includeGeometries}`)
  },

  getZoneProvince: function (
    x: number,
    y: number
  ): Promise<
    AxiosResponse<{ ZONE?: MeteoAlertZoneDTO; PROVINCE?: AlertProvinceDTO }>
  > {
    return request.get(`informe/getZoneProvinceByPoint?x=${x}&y=${y}`)
  }
}
